// Providers
export const PROVIDERS_REQUEST = "PROVIDERS_REQUEST";
export const PROVIDERS_SUCCESS = "PROVIDERS_SUCCESS";
export const PROVIDERS_ERROR = "PROVIDERS_ERROR";

// Locations
export const LOCATIONS_REQUEST = "LOCATIONS_REQUEST";
export const LOCATIONS_SUCCESS = "LOCATIONS_SUCCESS";
export const LOCATIONS_ERROR = "LOCATIONS_ERROR";

// Static Data
export const STATIC_REQUEST = "STATIC_REQUEST";
export const STATIC_SUCCESS = "STATIC_SUCCESS";
export const STATIC_ERROR = "STATIC_ERROR";

// Search
export const SEARCH_CHANGE_VALUE = "SEARCH_CHANGE_VALUE";
export const SEARCH_SET_FILTER = "SEARCH_SET_FILTER";
export const SEARCH_RESET_FILTER = "SEARCH_RESET_FILTER";


// Visibility
export const CLOSE_VERIFIED_TOOLTIP = "CLOSE_VERIFIED_TOOLTIP";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js